import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const PauseIcon = (props: SvgIconProps) => {
    const { viewBox = "-5 -5 20 20", ...rest } = props;

    return (
        <SvgIcon data-cy="pauseIcon" viewBox={viewBox} {...rest}>
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="square"
                strokeWidth="1"
            >
                <g
                    stroke="#21006E"
                    strokeWidth="2.5"
                    transform="translate(-71 -14)"
                >
                    <g transform="translate(56)">
                        <g transform="translate(16.19 16.19)">
                            <path d="M0.476 0L0.476 7.619"></path>
                            <path d="M7.143 0L7.143 7.619"></path>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
